<!-- =========================================================================================
  File Name: Order.vue
  Description:  order Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>

    <vs-alert color="danger" title="Orden no encontrada" :active.sync="id_not_found">
      <span>Datos de orden con id {{ $route.params.id }} no encontrados. </span>
      <span>
        <span>Verifique </span><router-link :to="{name:'orders'}" class="text-inherit underline"> todas las órdenes</router-link>
      </span>
    </vs-alert>

    <vx-card v-if="loaded" class="mb-2">

      <div slot="no-body" class="tabs-container pl-6 py-5">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-2/12">
            <div class="flex items-center justify-center h-12 rounded bg-success">
              <div class="text-3xl text-white text-bold">{{ data_local.id }}/{{ orderNumber }}</div>
            </div>
          </div>
          <div class="vx-col w-2/12">
            <label style="font-size: smaller;">Estado</label><br/>
            <b class="text-blue-800 text-bold">{{ data_local.status }}</b>
          </div>
          <div class="flex vx-col w-8/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-warning text-white cursor-pointer" @click="confirmStatus('Confirmado')" v-if="data_local.status == 'Procesando'">
              <vs-icon icon-pack="feather" icon="icon-check" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Confirmar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-primary text-white cursor-pointer" @click="confirmStatus('Facturado')" v-if="data_local.status == 'Confirmado'">
              <vs-icon icon-pack="feather" icon="icon-file-text" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Facturar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-success text-white cursor-pointer" @click="confirmStatus('Despachado')" v-if="data_local.status == 'Facturado'">
              <vs-icon icon-pack="feather" icon="icon-truck" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Despachar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-success text-white cursor-pointer" @click="confirmStatus('Entregado')" v-if="data_local.status == 'Despachado'">
              <vs-icon icon-pack="feather" icon="icon-user-check" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Entregado</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="confirmStatus('Cancelado')" v-if="data_local.status != 'Entregado'">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-2/12">
            <ejs-datetimepicker floatLabelType="Auto" placeholder="Fecha" v-model="data_local.date" locale="es-GT" :readonly="true"></ejs-datetimepicker>
          </div>
          <div class="vx-col w-8/12">
            <ejs-textbox floatLabelType="Auto" placeholder="Cliente" v-model="data_local.userName" :readonly="true"/>
          </div>
          <div class="vx-col w-2/12 items-end text-2xl mt-5 text-right">
            <b>Q{{ data_local.orderTotal.toLocaleString('en-US', {minimumFractionDigits: 2}) }}</b>
          </div>
        </div>
        <!--
                <div class="w-full vx-row items-center">
                  <div class="vx-col w-2/12 mt-2">
                    <ejs-dropdownlist highlight=true floatLabelType="Auto" placeholder="Moneda" :dataSource="currencies" :fields="{text: 'name', value: 'id'}" v-model="data_local.currencyId" :enabled="editing"/>
                  </div>
                  <div class="vx-col w-2/12 items-end text-2xl mt-5">
                    <b>{{ data_local.amount.toLocaleString('en-US', {minimumFractionDigits: 2}) }}</b>
                  </div>
                  <div class="vx-col w-8/12">
                    <ejs-textbox name="comments" :multiline="true" floatLabelType="Auto" placeholder="Comentarios" v-model="data_local.comments" :enabled="editing"/>
                  </div>
                </div>
        -->

      </div>
    </vx-card>

    <vx-card v-if="loaded">
      <vs-tabs>
        <vs-tab label="Productos">
          <div class="flex flex-wrap items-center mt-4">
            <ejs-grid v-if="loaded" ref="grid" id="grdOrderDetail" :dataSource="data_local.products" locale='es-GT' :toolbar='toolbarOptions' height="400px" :pageSettings='pageSettings'>
              <e-columns>
                <e-column field="productId" headerText="id" textAlign='Right' format="N0" width="100"/>
                <e-column field="isbn" headerText="ISBN" width="160"/>
                <e-column field="description" headerText="Descripción"/>
                <e-column field="quantity" headerText="Cantidad" textAlign='Right' format="N2" width="140"/>
                <e-column field="price" headerText="Precio" textAlign='Right' format="N2" width="140"/>
                <e-column field="amount" headerText="Valor" textAlign='Right' :valueAccessor='currencyFormatter2' width="140"/>
              </e-columns>
              <e-aggregates>
                <e-aggregate>
                  <e-columns>
                    <e-column type="Sum" field="amount" format="N2"/>
                  </e-columns>
                </e-aggregate>
              </e-aggregates>
            </ejs-grid>
          </div>
        </vs-tab>
        <vs-tab label="Información adicional">
          <div class="w-full vx-row mb-4">
            <div class="vx-col w-full">
              <ejs-textbox floatLabelType="Auto" placeholder="Dirección de despacho" v-model="data_local.address.address" :readonly="true"/>
              <br/>
              {{ data_local.address.cityName }}, {{ data_local.address.stateName}}
            </div>
          </div>
          <div class="w-full vx-row mb-4">
            <div class="vx-col w-full">
              <ejs-textbox floatLabelType="Auto" placeholder="Instrucciones para despacho" v-model="data_local.address.deliveryInstructions" :readonly="true"/>
              <br/>
            </div>
          </div>
          <div class="w-full vx-row">
            <div class="vx-col w-1/12">
              <ejs-textbox floatLabelType="Auto" placeholder="Teléfono" v-model="data_local.phone" :readonly="true"/>
              <br/>
            </div>
            <div class="vx-col w-5/12">
              <ejs-textbox floatLabelType="Auto" placeholder="Usuario" v-model="data_local.user" :readonly="true"/>
              <br/>
            </div>
            <div class="vx-col w-1/12">
              <ejs-textbox floatLabelType="Auto" placeholder="NIT" v-model="data_local.vat" :readonly="true"/>
              <br/>
            </div>
            <div class="vx-col w-5/12">
              <ejs-textbox floatLabelType="Auto" placeholder="Nombre a facturar" v-model="data_local.nameVat" :readonly="true"/>
              <br/>
            </div>
          </div>
          <div class="w-full vx-row" v-if="data_local.discount > 0">
            <div class="vx-col w-1/12">
              <ejs-textbox floatLabelType="Auto" placeholder="Cupón" v-model="data_local.couponCode" :readonly="true"/>
              <br/>
            </div>
            <div class="vx-col w-5/12">
              <ejs-textbox floatLabelType="Auto" placeholder="Descripción" v-model="data_local.couponName" :readonly="true"/>
              <br/>
            </div>
            <div class="vx-col w-1/12">
              <ejs-textbox floatLabelType="Auto" placeholder="Descuento (Q)" v-model="data_local.discount" :readonly="true"/>
              <br/>
            </div>
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
  </div>
</template>

<script>
  import Vue from "vue";
  import {loadCldr, L10n, setCulture} from '@syncfusion/ej2-base';
  import {GridPlugin, Toolbar, Search, Aggregate} from '@syncfusion/ej2-vue-grids';
  import {AutoComplete} from '@syncfusion/ej2-dropdowns';
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {DateTimePickerPlugin} from '@syncfusion/ej2-vue-calendars';
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';

  import numberingSystems from 'cldr-data/supplemental/numberingSystems.json';
  import gregorian from 'cldr-data/main/es-GT/ca-gregorian.json';
  import numbers from 'cldr-data/main/es-GT/numbers.json';
  import timeZoneNames from 'cldr-data/main/es-GT/timeZoneNames.json';
  import weekData from 'cldr-data/supplemental/weekData.json';// To load the culture based first day of week

  import {db} from '@/firebaseConfig';

  Vue.use(GridPlugin, AutoComplete);
  Vue.use(DropDownListPlugin);
  Vue.use(DateTimePickerPlugin);
  Vue.use(TextBoxPlugin);

  loadCldr(numberingSystems, gregorian, numbers, timeZoneNames, weekData);

  setCulture('es-GT');
  L10n.load({
    'es-GT': {
      'datetimepicker': {
        placeholder: 'Especifique fecha',
        today: 'Hoy'
      },
      'grid': {
        'EmptyRecord': 'Órden no tiene productos',
        'Search': 'Buscar',
        'Add': 'Agregar',
        'Edit': 'Modificar',
        'Cancel': 'Cancelar',
        'Update': 'Guardar',
        'Delete': 'Eliminar'
      }
    }
  });

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        pageSettings: {pageSize: 10},
        pagination: [10, 25, 50, 100],
        toolbarOptions: ['Search'],
        numericParams: {
          params: {
            validateDecimalOnType: true,
            decimals: 4,
            format: "N"
          }
        },
        id: 0,
        fbId: '',
        status: '',
        documentTypeId: 0,
        currencies: [],
        suppliers: [],
        products: [],
        data: null,
        data_local: {
          id: 0,
          orderNumber: '',
          date: new Date(),
          status: ''
        },
        id_not_found: false
      }
    },
    provide: {
      grid: [Toolbar, Search, Aggregate]
    },
    computed: {
      orderNumber() {
        return this.data_local.orderNumber ? this.data_local.orderNumber : this.data_local.id;
      }
    },
    methods: {
      currencyFormatter2: function (field, data, column) {
        return this.currencyFormatter(field, data, column, 2);
      },
      currencyFormatter4: function (field, data, column) {
        return this.currencyFormatter(field, data, column, 4);
      },
      currencyFormatter: function (field, data, column, decimals) {
        let value = '0.0000';
        if (typeof data[field] != 'undefined') {
          value = data[field].toLocaleString('en-US', {minimumFractionDigits: decimals});
        }
        return value;
      },
      getData(id) {
        if (id) {
          if (id > 0) {
            this.$vs.loading({
              text: 'Cargando información de orden',
              type: 'point'
            });
            const self = this;
            db.collection('orders')
              .where('id', '==', id)
              .get()
              .then(querySnapshot => {
                // self.fbId = querySnapshot.docs.data();
                self.data = querySnapshot.docs.map(doc => doc.data()).pop();
                self.data_local = JSON.parse(JSON.stringify(self.data));
                self.data_local.date = self.data.date.toDate();
                self.fbId = querySnapshot.docs[0].id;
                self.loaded = true;
                self.$vs.loading.close();
              })
              .catch((error) => {
                self.$vs.notify({
                  title: 'Error al cargar orden',
                  text: error.message,
                  color: 'danger'
                });
                self.$vs.loading.close();
              });
          }
        }
      },
      confirmStatus(status) {
        this.status = status;
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirmar`,
          text: `Se dispone a cambiar el estado de la orden ${this.data_local.orderNumber} a ${status}.`,
          accept: this.changeStatus,
          acceptText: "Confirmar",
          cancelText: 'Cancelar'
        })
      },
      changeStatus() {
        this.$vs.loading({
          text: 'Cambiando estado de orden',
          type: 'point'
        });
        const self = this;
        db.collection('orders').doc(this.fbId).update({status: this.status})
          .then(() => {
            self.getData(self.id);
            self.$vs.loading.close();
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'Error al actualizar orden',
              text: error.message,
              color: 'danger'
            });
            self.$vs.loading.close();
          });
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      this.getData(this.id);
    }
  }
</script>

<style lang="scss">
  @import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';
  @import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";
</style>
